import React, { useState, useEffect } from "react";

import {
  TouchableOpacity,
  View,
  StyleSheet,
  TextInput,
  TouchableWithoutFeedback,
  Keyboard,
  KeyboardAvoidingView,
  ActivityIndicator,
  Platform,
} from "react-native";
import { useDispatch } from "react-redux";
import Colors from "../../../constants/Colors";
import DefaultText from "../../../components/text/DefaultText";
import DefaultTextLight from "../../../components/text/DefaultTextLight";
import * as authActions from "../../../store/actions/auth";

const ProfileAuthScreen = (props) => {
  const { isSignup } = props.route.params;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [inputEmail, setInputEmail] = useState("");
  const [inputPassword, setInputPassword] = useState("");

  const inputEmailHandler = (enteredEmail) => {
    setInputEmail(enteredEmail);
  };
  const inputPasswordHandler = (enteredPassword) => {
    setInputPassword(enteredPassword);
  };

  const dispatch = useDispatch();

  const authHandler = async () => {
    let action;
    if (isSignup) {
      action = authActions.signup(inputEmail, inputPassword);
    } else {
      action = authActions.login(inputEmail, inputPassword);
    }
    setError(null);
    setIsLoading(true);
    try {
      console.log("action");
      await dispatch(action);
      console.log("action done");

      //props.navigation.navigate("ProfileUserScreen");
    } catch (err) {
      console.log("saw error:" + err);

      setError(err.message);
      setIsLoading(false);
    }
  };
  const dismissKeyboard = () => {
    if (Platform.OS != "web") {
      Keyboard.dismiss();
    }
  };
  return (
    <KeyboardAvoidingView
      behavior="padding"
      keyboardVerticalOffset={50}
      style={styles.screen}
    >
      <TouchableWithoutFeedback onPress={dismissKeyboard}>
        <View style={styles.keyboardContainer}>
          <View style={styles.emptyBox}></View>

          <View style={styles.headerContainer}>
            <DefaultText>Email</DefaultText>
          </View>
          <TextInput
            placeholderTextColor="white"
            onChangeText={inputEmailHandler}
            value={inputEmail}
            style={styles.inputContainer}
          />
          <View style={styles.headerContainer}>
            <DefaultText>Password</DefaultText>
            {isSignup ? (
              <View></View>
            ) : (
              <TouchableOpacity
                style={styles.forgot}
                onPress={() => {
                  props.navigation.navigate("ForgotPasswordScreen");
                }}
              >
                <DefaultTextLight style={styles.forgotText}>
                  Forgot
                </DefaultTextLight>
              </TouchableOpacity>
            )}
          </View>
          <TextInput
            placeholderTextColor="white"
            style={styles.inputContainer}
            onChangeText={inputPasswordHandler}
            value={inputPassword}
            secureTextEntry={true}
          />
          <TouchableOpacity
            style={styles.buttonContainer}
            onPress={authHandler}
          >
            <DefaultText style={{ fontSize: 16 }}>
              {isSignup ? "Sign Up" : "Log In"}
            </DefaultText>
          </TouchableOpacity>
          {isLoading ? (
            <ActivityIndicator size="small" color={Colors.primary} />
          ) : (
            <View></View>
          )}
        </View>
      </TouchableWithoutFeedback>
    </KeyboardAvoidingView>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
  },
  keyboardContainer: {
    height: "100%",
    alignItems: "center",
  },

  emptyBox: {
    height: "10%",
  },
  headerContainer: {
    width: "80%",
    marginBottom: 6,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  inputContainer: {
    color: "white",
    height: 40,
    width: "80%",
    borderBottomWidth: 1,
    fontFamily: "JosefinSans_400Regular",
    borderColor: "white",
    marginBottom: 55,
  },
  buttonContainer: {
    marginTop: 28,
    paddingVertical: 16,
    width: "80%",
    borderWidth: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "black",
    borderColor: "white",
    marginBottom: 10,
  },
  forgotText: {
    textDecorationLine: "underline",
  },
});

export default ProfileAuthScreen;
